import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import Overview from "@/pages/Overview";
import SkuMaster from "@/pages/SkuMaster";
import Stores from "@/pages/Stores";
import Dispatches from "@/pages/Dispatches";
import NewDispatch from "@/pages/NewDispatch";
import ImportChallan from "@/pages/ImportChallan";
import StoreDashboard from "@/pages/StoreDashboard";
import POS from "@/pages/POS";
import Inventory from "@/pages/Inventory";
import Inwarding from "@/pages/Inwarding";
import Barcodes from "@/pages/Barcodes";
import Invoices from "@/pages/Invoices";
import Reco from "@/pages/Reco";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";
import Audit from "@/pages/Audit";
import Customers from "@/pages/Customers";
import DayClose from "@/pages/DayClose";
import CashRegister from "@/pages/CashRegister";
import CreditNotes from "@/pages/CreditNotes";
import PendingPayments from "@/pages/PendingPayments";
import CompanySettings from "@/pages/CompanySettings";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500 text-sm">
        Loading…
      </div>
    );
  }
  if (!user || !user.id) return <Navigate to="/login" replace />;
  return children;
}

// Redirects /store/<stale-or-deleted-id>/... to the same page for the first
// store the user can access (e.g. after a store was deleted or renamed).
function StoreGuard({ children }) {
  const { stores } = useAuth();
  const { storeId } = useParams();
  const location = useLocation();
  if (stores.length > 0 && !stores.some((s) => s.id === storeId)) {
    return <Navigate to={location.pathname.replace(storeId, stores[0].id)} replace />;
  }
  return children;
}

function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Protected><Overview /></Protected>} />
        <Route path="/warehouse/skus" element={<Protected><SkuMaster /></Protected>} />
        <Route path="/warehouse/dispatches" element={<Protected><Dispatches /></Protected>} />
        <Route path="/warehouse/dispatches/new" element={<Protected><NewDispatch /></Protected>} />
        <Route path="/warehouse/dispatches/import" element={<Protected><ImportChallan /></Protected>} />
        <Route path="/stores" element={<Protected><Stores /></Protected>} />
        <Route path="/store/:storeId" element={<Protected><StoreGuard><StoreDashboard /></StoreGuard></Protected>} />
        <Route path="/store/:storeId/pos" element={<Protected><StoreGuard><POS /></StoreGuard></Protected>} />
        <Route path="/store/:storeId/inventory" element={<Protected><StoreGuard><Inventory /></StoreGuard></Protected>} />
        <Route path="/store/:storeId/inwarding" element={<Protected><StoreGuard><Inwarding /></StoreGuard></Protected>} />
        <Route path="/store/:storeId/barcodes" element={<Protected><StoreGuard><Barcodes /></StoreGuard></Protected>} />
        <Route path="/store/:storeId/invoices" element={<Protected><StoreGuard><Invoices /></StoreGuard></Protected>} />
        <Route path="/store/:storeId/reco" element={<Protected><StoreGuard><Reco /></StoreGuard></Protected>} />
        <Route path="/store/:storeId/reports" element={<Protected><StoreGuard><Reports /></StoreGuard></Protected>} />
        <Route path="/store/:storeId/day-close" element={<Protected><StoreGuard><DayClose /></StoreGuard></Protected>} />
        <Route path="/store/:storeId/cash" element={<Protected><StoreGuard><CashRegister /></StoreGuard></Protected>} />
        <Route path="/store/:storeId/credit-notes" element={<Protected><StoreGuard><CreditNotes /></StoreGuard></Protected>} />
        <Route path="/store/:storeId/pending-payments" element={<Protected><StoreGuard><PendingPayments /></StoreGuard></Protected>} />
        <Route path="/customers" element={<Protected><Customers /></Protected>} />
        <Route path="/settings/company" element={<Protected><CompanySettings /></Protected>} />
        <Route path="/users" element={<Protected><Users /></Protected>} />
        <Route path="/audit" element={<Protected><Audit /></Protected>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

export default App;
